import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { EcommerceCategories, RemoteConfig } from '../../models';
import { FirestoreService } from '../firestore/firestore.service';
import { PlatformService } from '../platform/platform.service';
import { RemoteConfigsService } from './remote-configs.service';

const COLLECTION_PATH = 'remoteConfigs';

@Injectable()
export class RemoteConfigsServiceApi implements RemoteConfigsService {
  constructor(
    @Inject('appFirestore') private firestore: FirestoreService,
    private http: HttpClient,
    private platformService: PlatformService,
  ) {}

  get(): Observable<RemoteConfig | null> {
    return this.firestore.doc(`${COLLECTION_PATH}/remote-configs`);
  }

  getEcommerceCategories(): Promise<EcommerceCategories | null> {
    if (this.platformService.isServer()) {
      return firstValueFrom(this.http.get<EcommerceCategories>('http://localhost:3000/ecommerce-categories.json')).catch((error) => {
        console.error('Local cache server error in RemoteConfigsServiceApi at getEcommerceCategories()', error);
        return firstValueFrom(this.firestore.doc<EcommerceCategories>(`${COLLECTION_PATH}/ecommerce-categories`));
      });
    }
    return firstValueFrom(this.firestore.doc<EcommerceCategories>(`${COLLECTION_PATH}/ecommerce-categories`));
  }
}